import { call, put } from 'redux-saga/effects';
import axios from '../../axiosConfig';
import { TOAST_SHOW } from '../Actions/ToastAction';
import { GET_FEEDBACK_SUCCESS, GET_FEEDBACK_FAILED, REMOVE_FEEDBACK_SUCCESS, REMOVE_FEEDBACK_FAILED } from '../Actions/FeedBack';
import decryptResponse from "../../Components/Decrypt";
export function* getFeedBackSaga(action) {
  try {
    const response = yield call(axios.post, `/feedbacks`, action.payload);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_FEEDBACK_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_FEEDBACK_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: 'error',
      },
    });
  }
}

export function* RemoveFeedbackSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `delete-feedback/${action?.payload?.Id}`
    );
    const { message } = response?.data;
    yield put({ type: REMOVE_FEEDBACK_SUCCESS, payload: action?.payload?.Id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: 'success' },
    });
  } catch (e) {
    yield put({ type: REMOVE_FEEDBACK_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: 'error',
      },
    });
  }
}
